import BeneficiarioLoteController from './beneficiario-lote/benef-lote-controller';
import LoteController from './lote-controller';
import MovimentacaoLoteController from './movimentacao-lote-controller';

export {
  BeneficiarioLoteController,
  LoteController,
  MovimentacaoLoteController,
};
